
import { Col, Row} from "react-bootstrap";
import { getImages } from "../../services/Servicos";
import "./politica.scss";

export function PoliticaDePrivacidade() {
	
	return (
		<>
			<Row className="mx-auto">
				<Col sm="12" lg='6' className="brand-viwer-login p-0 d-none d-lg-block">
					<BrandView />
				</Col>
				<Col sm="12" lg='6' style={{padding:"30px", overflow: "hidden", overflowY:"auto", height:'100vh'}}>
					<h1 style={{fontSize:"2rem", color: "black"}}>Política de Privacidade</h1>
					<ul>
						<li>Aplicativo: <b>B-LOG Logística Inteligente</b></li>
					</ul>
					<ul>
						<li>Responsável: <b>Bn Automação</b></li>
					</ul>
					<ul>
						<li>Última atualização: <b>23/04/2025</b></li>
					</ul>
					<p>A sua privacidade é importante para nós. Esta Política de Privacidade tem como objetivo esclarecer como coletamos, utilizamos, armazenamos, protegemos e, quando necessário, compartilhamos seus dados pessoais quando você utiliza o aplicativo <b>B-LOG Logística Inteligente</b>. Ao utilizar nosso aplicativo, você concorda com esta política e consente com o tratamento de seus dados conforme descrito abaixo.</p>
					<p>1. INFORMAÇÕES COLETADAS</p>
					<h4>1.1 Informações fornecidas diretamente por você</h4>
					<p>Podemos coletar informações que você fornece ao usar nosso aplicativo, como:</p>
					<b>
						<li>Nome completo</li>
						<li>Endereço de e-mail</li>
						<li>Número de telefone</li>
						<li>Outras informações fornecidas em formulários ou cadastros</li>
					</b>
					<h4>1.2 Informações coletadas automaticamente</h4>
					<p>Ao usar nosso aplicativo, coletamos automaticamente certas informações, tais como:</p>
					<p>Dados de uso: interações com funcionalidades do app, tempo de uso, cliques, páginas acessadas.</p>
					<p>Dados do dispositivo: tipo de dispositivo, sistema operacional, identificadores únicos, idioma, fuso horário.</p>
					<p>Dados de localização: com o seu consentimento, coletamos dados de GPS ou localização aproximada.</p>
					<h4>1.3 Informações de terceiros</h4>
					<p>Podemos receber dados de terceiros, como plataformas de autenticação (ex: login com Google ou Facebook), respeitando as permissões que você concedeu nessas plataformas.</p>
					<h4>2. FINALIDADE DO TRATAMENTO DE DADOS</h4>
					<p>Os dados coletados são utilizados para:</p>
					<p>Personalizar sua experiência no aplicativo</p>
					<p>Melhorar a funcionalidade e o desempenho da aplicação</p>
					<p>Processar solicitações, cadastros e suporte técnico</p>
					<p>Enviar notificações, atualizações ou comunicações (quando autorizado)</p>
					<p>Prevenir fraudes e garantir a segurança dos usuários</p>
					<p>Cumprir obrigações legais e regulatórias</p>
					<h4>3. COMPARTILHAMENTO DE DADOS</h4>
					<p>Não vendemos seus dados pessoais a terceiros. Seus dados podem ser compartilhados apenas quando:</p>
					<p>Necessário para prestação de serviços por terceiros parceiros (ex: provedores de hospedagem, analytics, ferramentas de notificações)</p>
					<p>Exigido por lei ou mediante ordem judicial</p>
					<p>Em caso de transações corporativas, como fusão, aquisição ou venda de ativos, desde que assegurada a confidencialidade</p>
					<h4>4. BASE LEGAL PARA O TRATAMENTO DE DADOS</h4>
					<p>Tratamos seus dados com base nas seguintes justificativas legais:</p>
					<p>Consentimento (ex: envio de notificações)</p>
					<p>Execução de contrato (ex: funcionalidade do aplicativo)</p>
					<p>Cumprimento de obrigação legal</p>
					<p>Interesse legítimo, desde que não fira os direitos e liberdades fundamentais do titular dos dados</p>
					<h4>5. RETENÇÃO E EXCLUSÃO DOS DADOS</h4>
					<p>Armazenamos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades mencionadas nesta política. Após esse período, os dados serão eliminados, exceto se houver justificativa legal para mantê-los.</p>
					<p>Você pode solicitar a exclusão dos seus dados a qualquer momento, enviando um e-mail para <b>codji.suporte@gmail.com</b>.</p>
					<h4>6. DIREITOS DO TITULAR DOS DADOS</h4>
					<p>Você tem os seguintes direitos:</p>
					<p>Confirmar a existência de tratamento de dados</p>
					<p>Acessar seus dados</p>
					<p>Corrigir dados incompletos ou desatualizados</p>
					<p>Solicitar anonimização, bloqueio ou eliminação de dados</p>
					<p>Portabilidade dos dados</p>
					<p>Revogação do consentimento</p>
					<p>Reclamar perante a autoridade de proteção de dados (ex: ANPD, no Brasil)</p>
					<p>Para exercer seus direitos, entre em contato pelo e-mail: <b>codji.suporte@gmail.com</b></p>
					<h4>7. SEGURANÇA DAS INFORMAÇÕES</h4>
					<p>Adotamos medidas técnicas e organizacionais apropriadas para proteger seus dados contra acesso não autorizado, perda, destruição ou alteração. Entre as medidas adotadas estão:</p>
					<p>Criptografia de dados sensíveis</p>
					<p>Acesso restrito aos dados por funcionários autorizados</p>
					<p>Monitoramento de acessos e logs de atividades</p>
					<h4>8. TRANSFERÊNCIA INTERNACIONAL DE DADOS</h4>
					<p>Se os dados forem processados fora do seu país, garantimos que serão aplicadas salvaguardas adequadas, de acordo com os padrões legais internacionais, como cláusulas contratuais padrão da Comissão Europeia.</p>
					<h4>9. COOKIES E TECNOLOGIAS SEMELHANTES</h4>
					<p>Nosso aplicativo pode utilizar cookies ou tecnologias similares para melhorar sua experiência. Você pode controlar o uso dessas tecnologias através das configurações do seu dispositivo.</p>
					<h4>10. ALTERAÇÕES NESTA POLÍTICA</h4>
					<p>Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre mudanças relevantes por meio do próprio aplicativo ou por outros canais apropriados. Recomendamos que você revise esta política regularmente.</p>
					<h4>11. CONTATO</h4>
					<p>Se você tiver dúvidas, sugestões ou solicitações relacionadas a esta Política de Privacidade, entre em contato conosco:</p>
					<p>Responsável: <b>BN Automação</b></p>
					<p>E-mail: <b>codji.suporte@gmail.com</b></p>
				</Col>
			</Row>
		</>
	);
}


function BrandView() {
	return (
		<div className="d-flex text-center justify-content-center" style={{height: '100vh'}}>
			<img src={getImages("logos-empresa/b-log.png")} />
		</div>
	);
}
